import script from "./LatestActionLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./LatestActionLogs.vue?vue&type=script&setup=true&lang=js"

import "./LatestActionLogs.vue?vue&type=style&index=0&id=df37ee82&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df37ee82"]])

export default __exports__